// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1573":"b2ca7b029a2dd25f","4268":"76e9143623317cd8","9022":"588a4ff96a7bd064"}[chunkId] + ".js";
};